export const styles = {
  style: {
    flex: 1
  }
};
